import { memo, type ReactNode } from 'react';
import cn from 'classnames';
import { Header, Text, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import styles from './DrawerHeader.module.css';

interface DrawerHeaderProps extends TestProps {
    title?: ReactNode;
    subtitle?: ReactNode;
    className?: string;
}

export const DrawerHeader = memo<DrawerHeaderProps>(function DrawerHeader({
    'data-testid': dataTestId = 'DrawerHeader',
    title,
    subtitle,
    className,
}) {
    if (!title && !subtitle) {
        return null;
    }

    return (
        <VStack data-testid={dataTestId} gap="4" className={cn(styles.header, className)}>
            {title && (
                <Header level="h3" className={styles.title}>
                    {title}
                </Header>
            )}

            {subtitle && (
                <Text size="m" role="supplementary" className={styles.subtitle}>
                    {subtitle}
                </Text>
            )}
        </VStack>
    );
});
